import { Constants } from '../constants/constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from '../utils/utils';

declare let $: any;

@Injectable({
  providedIn: 'root'
})
export class EntregaService {

  constructor(private http: HttpClient, private utils:Utils) { }

  public getInformeEntregas(agencia, usuarioConsulta, idUsuario, fechaInicial, fechaFinal, tipoConsulta): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ENTREGAS + '/' + idUsuario + '/' + fechaInicial + '/' + fechaFinal + '/' + tipoConsulta + '/' + agencia + '/' + usuarioConsulta;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: 'Error Entregas',
            text: 'Error Cargando Entregas.',
            type: 'error'
          });
        }
        
        return throwError(err);
      })
    );
  }


  public getInformeEntregasRealizadas(agencia, usuarioConsulta, idUsuario, fechaInicial, fechaFinal): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ENTREGAS + '/' + idUsuario + '/' + fechaInicial + '/' + fechaFinal + '/' + agencia + '/' + usuarioConsulta;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: 'Error Entregas',
            text: 'Error Cargando Entregas Realizadas.',
            type: 'error'
          });
        }
        
        return throwError(err);
      })
    );
  }
}
